const Size = () =>
  import(
    /* webpackChunkName: "base-info-feature-size" */ '@/pages/base-info/feature/size/index.vue'
  )
const CreateSize = () =>
  import(
    /* webpackChunkName: "base-info-feature-size" */ '@/pages/base-info/feature/size/create.vue'
  )
const EditSize = () =>
  import(
    /* webpackChunkName: "base-info-feature-size" */ '@/pages/base-info/feature/size/edit.vue'
  )

export default {
  path: 'size',
  meta: {
    label: 'size',
    auth: 'size'
  },
  component: {
    name: 'Size',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFeatureSize',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Size
    },
    {
      name: 'BaseInfoCreateFeatureSize',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSize
    },
    {
      name: 'BaseInfoEditFeatureSize',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSize,
      props: true
    }
  ]
}
